
import _cloneDeep from 'lodash/cloneDeep';
import { ProcessConfig, QuestionConfig, StatusConfig } from './../models/config.model';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChildren, ViewEncapsulation } from "@angular/core";
import { TooltipDialog } from '../tooltip-dialog/tooltip-dialog.component';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { showToast } from '../../toast.helper';
import { FormioLoader, ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-question-content',
    templateUrl: './question-content.component.html',
    // styleUrls: ['./question-content.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class QuestionContentComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChildren('forms') forms: QueryList<any>;
    @Input() orginalQuestion: QuestionConfig;
    @Input() processConfig: ProcessConfig;
    @Input() viewOnly: boolean;
    @Input() customOptions: any;
    @Input() dir;
    @Output() questionChanged = new EventEmitter<QuestionConfig>();
    @Output() loading = new EventEmitter<boolean>();
    showForm = true;
    formReady = true;
    question: QuestionConfig;

    answerArray: Array<{ value: string, tooltip: string }> = [];
    linkPattern = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;

    sub: Subscription;

    constructor(private dialog: MatDialog,
        public formioLoader: FormioLoader,
        private resourceNameService: ResourceNameService,
        private toastrService: ToastrService,
        private translateService: TranslateService) {
    }

    ngOnInit() {
        this.formioLoader.loading = false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.orginalQuestion) {
            this.question = _cloneDeep(this.orginalQuestion);
            this.initAnswers();
        }
    }
    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    anwserChange(value) {
        this.question.value = `${value}`;
    }

    showDialog(message: string) {
        const dialogRef = this.dialog.open(TooltipDialog, {
            width: '80%',
            data: {
                dir: this.dir,
                message: this.translateService.instant(message)
            }
        });
    }

    changeApply() {
        if (this.question.notApply) {
            this.question.value = '';
            this.question.linkValue = '';
            this.question.notesValue = '';
            this.question.pledgeValue = false;

            this.question?.attachments?.forEach(q => q.data = []);
            this.question?.evaluationItems?.forEach(q => q.score = '');
        }
        this.showForm = false;
        this.formReady = false;
        setTimeout(() => this.formReady = true);
    }

    formLoad(formSettings) {
        setTimeout(() => {
            const array = $('.question-content [name="data[submit]"]');
            for (let index = 0; index < array.length; index++) {
                $(array[index]).hide();
            }
            this.showForm = true;
        }, 250);
    }

    saveQuestion() {
        this.question.status = StatusConfig.Complete;
        this.formioLoader.loading = true;
        this.loading.emit(true);

        this.sub = this.resourceNameService.editSubmission(this.customOptions.questionsResource,
            this.question._id, { data: this.mapQuestion() })
            .subscribe(data => {
                this.formioLoader.loading = false;
                this.questionChanged.emit(this.question);
            }, error => {
                this.formioLoader.loading = false;
                this.loading.emit(false);
                showToast(this.toastrService,
                    this.translateService.instant("ErrorOccurred"),
                    this.translateService.instant("generalError"),
                    true
                );
            });
    }

    private initAnswers() {
        if (this.processConfig?.answerMaxScore) {
            const generalToolTip = this.question.answerTooltip ? this.question.answerTooltip.find(q => !q.score) : { tooltip: '' };
            this.answerArray = Array.from({ length: this.processConfig.answerMaxScore }, (_, i) => {
                return {
                    value: `${i + 1}`,
                    tooltip: generalToolTip?.tooltip ?? this.question.answerTooltip.find(q => q.score == i + 1)?.tooltip
                }
            });
        }
    }

    private mapQuestion() {
        const question = _cloneDeep(this.question);
        question.evaluationItems?.forEach(q => q.score = `${q.score}`);
        delete question.parentCategoryObject;
        delete question._id;
        return question;
    }
}